
import { selector } from 'recoil';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { sortFieldListByOrder } from '@/component/formManagement/handler/CommonHandler';
import { projectInuseDetailAtom, projectListInCorporationAtom } from '@/state/atom/projectAtom';
import { fieldListOfCorporationAtom, listFormOfCorporationAtom } from '@/state/atom/formAtom';
import { cloneDeep } from 'lodash';


export const formListOfProjectSelector = selector({
    key: 'formListOfProjectSelector',
    get: async ({ get }) => {
        try {
            // get projectInuse
            let projectInuse = get(projectInuseDetailAtom);
            let projectId = projectInuse.id;
            let corporationId = projectInuse.affiliationOrganization;
            let listFormOfCorporation = get(listFormOfCorporationAtom);
            // list project by corporation
            let listProjectByCorp = get(projectListInCorporationAtom);

            let listFormOfProject = cloneDeep(listFormOfCorporation);
            for (let i = 0; i < listFormOfProject.length; i++) {

                if(listFormOfProject[i].usingTickets){
                    const usingTickets = JSON.parse(listFormOfProject[i].usingTickets);
                    listFormOfProject[i].isInuse = Utils.isEmptyObject(usingTickets) ? false : true
                }else{
                    listFormOfProject[i].isInuse = false
                }
                
                if (listFormOfProject[i].usingProjects.includes(projectId)) {
                    listFormOfProject[i].isProjectInuse = true;
                } else {
                    listFormOfProject[i].isProjectInuse = false;
                }

                //add definition name of form
                if (listFormOfProject[i].definition === Constant.FORM_DEFINITION.SYSTEM) {
                    listFormOfProject[i].definitionName = Constant.FORM_DEFINITION_NAME.SYSTEM;
                } else if (listFormOfProject[i].definition === Constant.FORM_DEFINITION.SAMPLE) {
                    listFormOfProject[i].definitionName = Constant.FORM_DEFINITION_NAME.SAMPLE;
                } else {
                    let project = listProjectByCorp.find(
                        (x) => x.id === listFormOfProject[i].affiliationProject
                    );
                    if (!Utils.isEmpty(project)) {
                        listFormOfProject[i].definitionName = Utils.getTextByLanguage(
                            Constant.LANGUAGE_TYPE.JP,
                            project.name
                        );
                    } else {
                        listFormOfProject[i].definitionName = '';
                    }
                }

                // isShared form
                if (listFormOfProject[i].affiliationOrganization === corporationId) {
                    listFormOfProject[i].isShared = false;
                } else {
                    listFormOfProject[i].isShared = true;
                }
            }
            return listFormOfProject;
        } catch (err) {
            console.error(`formListSelector error: ${err}`);
            return [];
        }
    },
    set: ({ set }, newValue) => {
        let newListFormCorporation = [];

        let newValueClone = Utils.isEmptyArray(newValue) ? [] : cloneDeep(newValue);
        newValueClone.forEach(form => {
            if (form?.hasOwnProperty('isProjectInuse')) {
                delete form.isProjectInuse;
            }
            newListFormCorporation.push(form);
        });

        set(listFormOfCorporationAtom, [...newListFormCorporation]);
    },
    cachePolicy_UNSTABLE: {
        // Only store the most recent set of dependencies and their values
        eviction: 'most-recent'
    }
});

export const fieldListOfProjectSelector = selector({
    key: 'fieldListOfProjectSelector',
    get: async ({ get }) => {
        try {
            // get projectInuse
            let projectInuse = get(projectInuseDetailAtom);
            let projectId = projectInuse.id;

            let getFieldListInCorporationState = get(fieldListOfCorporationAtom);
            let getFieldListInCorporation = cloneDeep(getFieldListInCorporationState);

            // check isProjectInuse
            if (!Utils.isEmpty(projectId) && !Utils.isEmptyArray(getFieldListInCorporation)) {
                getFieldListInCorporation.forEach(field => {
                    field.isProjectInuse =
                        !Utils.isEmptyArray(field.usingProjects) &&
                        field.usingProjects.includes(projectId);
                    field.isUsingProject = field.isProjectInuse;
                });
            }

            let sortFieldListOfProject = sortFieldListByOrder(getFieldListInCorporation, {
                id: projectId
            });

            return sortFieldListOfProject;
        } catch (err) {
            console.error(`formListSelector error: ${err}`);
            return [];
        }
    },
    set: ({ set }, newValue) => {
        let newListFieldCorporation = [];
        let newValueClone = Utils.isEmptyArray(newValue) ? [] : cloneDeep(newValue);
        newValueClone.forEach(field => {
            if (field?.hasOwnProperty('isProjectInuse')) {
                delete field.isProjectInuse;
            }

            if (field?.hasOwnProperty('isUsingProject')) {
                delete field.isUsingProject;
            }
            newListFieldCorporation.push(field);
        });
        set(fieldListOfCorporationAtom, [...newListFieldCorporation]);
    },
    cachePolicy_UNSTABLE: {
        // Only store the most recent set of dependencies and their values
        eviction: 'most-recent'
    }
});